import { render, staticRenderFns } from "./FavoriteShopListPage.vue?vue&type=template&id=d2456c9c&"
import script from "./FavoriteShopListPage.vue?vue&type=script&lang=js&"
export * from "./FavoriteShopListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports